import { device } from "emoreg/const";
import { css } from "styled-components";

export const forTabletUp = (...args) => css`
  @media (min-width: ${device.mobile / 16}em) {
    ${css(...args)};
  }
`;
